(function () {
  var root = document.getElementById('plate-gen-root');
  if (!root || root.getAttribute('data-pg-initialized') === 'true') { return; }
  root.setAttribute('data-pg-initialized', 'true');

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SQUARE = 14, INNER_WALL_BASE = 16, MIN_PITCH = 19.05;
  var EXPORT_STROKE = 0.01, PREVIEW_STROKE = 0.5;
  var FIXED_HEIGHTS = { p2: 5, p3: 2, p4: 1.5 };

  function getPartHeights(p1h, p5h) { return { p1: p1h, p2: FIXED_HEIGHTS.p2, p3: FIXED_HEIGHTS.p3, p4: FIXED_HEIGHTS.p4, p5: p5h }; }
  function getTotalHeight(p1h, p5h) { return p1h + FIXED_HEIGHTS.p2 + FIXED_HEIGHTS.p3 + FIXED_HEIGHTS.p4 + p5h; }

  var COLORS = { black: '#231F20', green: '#00A651', red: '#ED1C24', blue: '#2E3192' };

  var rowsInput        = root.querySelector('#pg-rows');
  var colsInput        = root.querySelector('#pg-cols');
  var pitchInput       = root.querySelector('#pg-pitch');
  var outerWallInput   = root.querySelector('#pg-outerwall');
  var innerRadiusInput = root.querySelector('#pg-innerradius');
  var outerRadiusInput = root.querySelector('#pg-outerradius');
  var p1HeightInput    = root.querySelector('#pg-p1-height');
  var p5HeightInput    = root.querySelector('#pg-p5-height');
  var pitchError       = root.querySelector('#pg-pitch-error');
  var innerWallValueEl = root.querySelector('#pg-innerwall-value');
  var totalHeightEl    = root.querySelector('#pg-total-height-value');
  var preview          = root.querySelector('#pg-preview');
  var spec             = root.querySelector('#pg-spec');
  var viewSvgBtn       = root.querySelector('#pg-view-svg');
  var advToggle        = root.querySelector('#pg-advanced-toggle');
  var advPanel         = root.querySelector('#pg-advanced');
  var framelessToggle  = root.querySelector('#pg-frameless-toggle');
  var outerWallStepper = root.querySelector('#pg-outerwall-stepper');
  var outerWallStepper = root.querySelector('#pg-outerwall-stepper');
var p5Stepper = root.querySelector('#pg-p5-height').parentElement;

  var framelessMode    = false;

  [['display','flex'],['align-items','center'],['justify-content','center'],
   ['width','100%'],['max-width','480px'],['height','480px'],
   ['overflow','hidden'],['box-sizing','border-box'],['margin','0 auto']
  ].forEach(function(p){ preview.style.setProperty(p[0],p[1],'important'); });

  advToggle.addEventListener('click', function () {
    var open = advPanel.classList.toggle('pg-open');
    advToggle.textContent = (open ? '– ' : '+ ') + 'Advanced settings';
  });

function setFramelessMode(active) {
  framelessMode = active;
  framelessToggle.textContent = active ? 'Enable Border' : 'Disable Border';
  framelessToggle.classList.toggle('pg-frameless-active', active);
  if (outerWallStepper) outerWallStepper.classList.toggle('pg-disabled', active);
  if (p5Stepper) p5Stepper.classList.toggle('pg-disabled', active);
  if (p5HeightInput) p5HeightInput.value = active ? 0 : 7.5;
  render();
  if (typeof modalOverlay !== 'undefined' && modalOverlay.classList.contains('pg-modal-open') && three) refreshModel(true);
}

  framelessToggle.addEventListener('click', function () { setFramelessMode(!framelessMode); });

  function clampInt(v,lo,hi){ v=parseInt(v,10); if(isNaN(v))v=lo; return Math.min(hi,Math.max(lo,v)); }
  function clampFloat(v,lo,hi){ v=parseFloat(v); if(isNaN(v))v=lo; return Math.min(hi,Math.max(lo,v)); }
  function round(n){ return Math.round(n*10000)/10000; }

  function computeGeometry(rows,cols,pitch,outerWall){
    var half=SQUARE/2, innerWall=Math.max(0,pitch-INNER_WALL_BASE);
    var black=[],green=[];
    for(var r=0;r<rows;r++){
      for(var c=0;c<cols;c++){
        var cx=c*pitch,cy=r*pitch;
        black.push({x:cx-half,y:cy-half,w:SQUARE,h:SQUARE});
        green.push({x:cx-7.5,y:cy-2.5,w:15,h:5});
        green.push({x:cx-2.5,y:cy-7.5,w:5,h:15});
      }
    }
    var bL=-half,bT=-half,bR=(cols-1)*pitch+half,bB=(rows-1)*pitch+half;
    var red={x:bL-innerWall,y:bT-innerWall,w:(bR-bL)+innerWall*2,h:(bB-bT)+innerWall*2};
    var blue={x:red.x-outerWall,y:red.y-outerWall,w:red.w+outerWall*2,h:red.h+outerWall*2};
    return {black:black,green:green,red:red,blue:blue,innerWall:innerWall};
  }

  var REFERENCE_GEO=computeGeometry(5,5,19.05,3);
  var FRAME_INTERIOR_PX=440;
  var PX_PER_MM=FRAME_INTERIOR_PX/Math.max(REFERENCE_GEO.blue.w,REFERENCE_GEO.blue.h);

  function svgEl(tag,attrs){
    var el=document.createElementNS(SVG_NS,tag);
    for(var k in attrs){if(attrs.hasOwnProperty(k)&&attrs[k]!=null)el.setAttribute(k,attrs[k]);}
    return el;
  }
  function rectEl(rect,color,sw,dx,dy,radius){
    var a={x:round(rect.x+dx),y:round(rect.y+dy),width:round(rect.w),height:round(rect.h),fill:'none',stroke:color,'stroke-width':sw};
    if(radius){a.rx=round(radius);a.ry=round(radius);}
    return svgEl('rect',a);
  }
  function crossSVGEl(cx,cy,color,sw,dx,dy){
    var pts=[[cx-2.5,cy-7.5],[cx+2.5,cy-7.5],[cx+2.5,cy-2.5],[cx+7.5,cy-2.5],[cx+7.5,cy+2.5],[cx+2.5,cy+2.5],[cx+2.5,cy+7.5],[cx-2.5,cy+7.5],[cx-2.5,cy+2.5],[cx-7.5,cy+2.5],[cx-7.5,cy-2.5],[cx-2.5,cy-2.5]].map(function(p){return round(p[0]+dx)+','+round(p[1]+dy);}).join(' ');
    return svgEl('polygon',{points:pts,fill:'none',stroke:color,'stroke-width':sw});
  }

  function buildSVGElement(geo,sw,includeGreen,pixelScale,innerRadius,outerRadius){
  var br=framelessMode?geo.red:geo.blue;
  var margin=sw/2,width=br.w+sw,height=br.h+sw,dx=-br.x+margin,dy=-br.y+margin;
  var svg=svgEl('svg',{xmlns:SVG_NS,viewBox:'0 0 '+round(width)+' '+round(height)});
  if(pixelScale){
    var pxW=round(width*pixelScale),pxH=round(height*pixelScale);
    svg.setAttribute('width',pxW);svg.setAttribute('height',pxH);
    svg.style.setProperty('display','block','important');
    svg.style.setProperty('width',pxW+'px','important');
    svg.style.setProperty('height',pxH+'px','important');
    svg.style.setProperty('max-width','100%','important');
    svg.style.setProperty('max-height','100%','important');
  } else {
    var DPI=96,MM_PER_INCH=25.4,PX_PER_MM=DPI/MM_PER_INCH;
    var vbW=round(width*PX_PER_MM),vbH=round(height*PX_PER_MM);
    svg.setAttribute('width',round(width)+'mm');
    svg.setAttribute('height',round(height)+'mm');
    svg.setAttribute('viewBox','0 0 '+vbW+' '+vbH);
  }

  if(!framelessMode) svg.appendChild(rectEl(geo.blue,COLORS.blue,sw,dx,dy,outerRadius));
  svg.appendChild(rectEl(geo.red,COLORS.red,sw,dx,dy,innerRadius));
  if(includeGreen){geo.black.forEach(function(b){svg.appendChild(crossSVGEl(b.x+7,b.y+7,COLORS.green,sw,dx,dy));});}
  geo.black.forEach(function(b){svg.appendChild(rectEl(b,COLORS.black,sw,dx,dy));});

  if(!pixelScale){
    var scaleGroup=document.createElementNS(SVG_NS,'g');
    scaleGroup.setAttribute('transform','scale('+round(DPI/MM_PER_INCH)+')');
    while(svg.firstChild) scaleGroup.appendChild(svg.firstChild);
    svg.appendChild(scaleGroup);
  }

  return {element:svg,width:width,height:height};
}



  function readInputs(){
    var rows=clampInt(rowsInput.value,1,10),cols=clampInt(colsInput.value,1,10);
    rowsInput.value=rows;colsInput.value=cols;
    var rawPitch=parseFloat(pitchInput.value),pitchInvalid=!isNaN(rawPitch)&&rawPitch<MIN_PITCH;
    var pitch=clampFloat(pitchInput.value,MIN_PITCH,60);
    pitchError.classList.toggle('pg-show',pitchInvalid);
    var outerWall=clampFloat(outerWallInput.value,1,50);
    var innerRadius=clampFloat(innerRadiusInput.value,0,10);
    var outerRadius=clampFloat(outerRadiusInput.value,0,30);
    var p1h=Math.round(clampFloat(p1HeightInput?p1HeightInput.value:1.5,0,5)*2)/2;
    var p5h=Math.round(clampFloat(p5HeightInput?p5HeightInput.value:7.5,0,10)*2)/2;
    if(totalHeightEl) totalHeightEl.textContent=round(getTotalHeight(p1h,p5h)).toFixed(1)+'mm';
    return {rows:rows,cols:cols,pitch:pitch,outerWall:outerWall,innerRadius:innerRadius,outerRadius:outerRadius,p1h:p1h,p5h:p5h};
  }

  function clearChildren(el){while(el.firstChild)el.removeChild(el.firstChild);}
  function specRow(label,value){
    var row=document.createElement('div');
    row.appendChild(document.createTextNode(label+': '));
    var ve=document.createElement('span');ve.textContent=value;row.appendChild(ve);
    return row;
  }

  function render(){
    var v = readInputs(), geo = computeGeometry(v.rows, v.cols, v.pitch, v.outerWall);
    var br = framelessMode ? geo.red : geo.blue;
    clearChildren(preview);
    var containerSize = Math.min((preview.clientWidth || window.innerWidth) - 32, FRAME_INTERIOR_PX);
    var fitScale = Math.min(containerSize / br.w, containerSize / br.h);
    var scale = Math.min(PX_PER_MM, fitScale);
    var result = buildSVGElement(geo, PREVIEW_STROKE, false, scale, v.innerRadius, v.outerRadius);
    preview.appendChild(result.element);
    innerWallValueEl.textContent = round(geo.innerWall).toFixed(2) + 'mm';
    clearChildren(spec);
    spec.appendChild(specRow('Cutouts', String(v.rows * v.cols)));
    spec.appendChild(specRow('Cutout Size', SQUARE + 'mm'));
    spec.appendChild(specRow('Spacing', round(v.pitch) + 'mm'));
    if(!framelessMode) spec.appendChild(specRow('Wall Thickness', round(v.outerWall) + 'mm'));
    spec.appendChild(specRow('Outer Radius', round(v.outerRadius) + 'mm'));
    spec.appendChild(specRow('Dimensions', round(result.width) + 'mm x ' + round(result.height) + 'mm'));
}


  function downloadSVG(){
    var v=readInputs(),geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var result=buildSVGElement(geo,EXPORT_STROKE,true,null,v.innerRadius,v.outerRadius);
    var xml='<?xml version="1.0" encoding="UTF-8"?>'+new XMLSerializer().serializeToString(result.element);
    var blob=new Blob([xml],{type:'image/svg+xml'}),url=URL.createObjectURL(blob);
    var a=document.createElement('a');a.href=url;a.download='plate-'+v.rows+'x'+v.cols+'.svg';
    document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
  }

  var svgModalOverlay=document.getElementById('pg-svg-modal-overlay');
  var svgModalClose=document.getElementById('pg-svg-modal-close');
  var svgModalCanvas=document.getElementById('pg-svg-modal-canvas');
  var svgModalSpec=document.getElementById('pg-svg-modal-spec');
  var svgDownloadBtn=document.getElementById('pg-svg-download');

function openSVGModal(){
  var v=readInputs(),geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
  var result=buildSVGElement(geo,EXPORT_STROKE,true,null,v.innerRadius,v.outerRadius);
  svgModalOverlay.classList.add('pg-modal-open');
  var canvasEl=svgModalCanvas;
  var availW=canvasEl.clientWidth-48;
  var availH=canvasEl.clientHeight-48;
  var scale=Math.min(availW/result.width, availH/result.height);
  var pxW=Math.round(result.width*scale),pxH=Math.round(result.height*scale);
  result.element.setAttribute('width',pxW);result.element.setAttribute('height',pxH);
  result.element.style.setProperty('width',pxW+'px','important');
  result.element.style.setProperty('height',pxH+'px','important');
  result.element.style.setProperty('max-width','100%','important');
  clearChildren(svgModalCanvas);svgModalCanvas.appendChild(result.element);
  clearChildren(svgModalSpec);
  svgModalSpec.appendChild(specRow('Dimensions',round(result.width)+'mm x '+round(result.height)+'mm'));
  svgModalSpec.appendChild(specRow('Cutouts',String(v.rows*v.cols)));
  

var infoTrigger = document.createElement('div');
infoTrigger.className = 'pg-info-trigger';
infoTrigger.innerHTML = '<span class="pg-info-icon">ⓘ</span>';
svgModalCanvas.appendChild(infoTrigger);

var infoTooltip = document.createElement('div');
infoTooltip.className = 'pg-info-tooltip';
infoTooltip.innerHTML = '<span>The SVG uses a true 0.01mm hairline stroke.</span>';
svgModalCanvas.appendChild(infoTooltip);


}


  
  function closeSVGModal(){svgModalOverlay.classList.remove('pg-modal-open');}

  viewSvgBtn.addEventListener('click',openSVGModal);
  svgModalClose.addEventListener('click',closeSVGModal);
  svgModalOverlay.addEventListener('click',function(e){if(e.target===svgModalOverlay)closeSVGModal();});
  svgDownloadBtn.addEventListener('click',downloadSVG);

  function bindStepper(inputId){
    var input=root.querySelector('#'+inputId),buttons=input.parentElement.querySelectorAll('button');
    buttons[0].addEventListener('click',function(){
      var step=parseFloat(input.getAttribute('step'))||1,min=parseFloat(input.getAttribute('min'));
      var cur=parseFloat(input.value);if(isNaN(cur))cur=min;
      input.value=Math.round(Math.max(min,cur-step)*100)/100;
      input.dispatchEvent(new Event('change'));
    });
    buttons[1].addEventListener('click',function(){
      var step=parseFloat(input.getAttribute('step'))||1,max=parseFloat(input.getAttribute('max'));
      var cur=parseFloat(input.value);if(isNaN(cur))cur=0;
      input.value=Math.round(Math.min(max,cur+step)*100)/100;
      input.dispatchEvent(new Event('change'));
    });
  }

  bindStepper('pg-rows');bindStepper('pg-cols');
  bindStepper('pg-outerwall');bindStepper('pg-outerradius');
  bindStepper('pg-p1-height');bindStepper('pg-p5-height');

  [rowsInput,colsInput,pitchInput,outerWallInput,innerRadiusInput,outerRadiusInput,p1HeightInput,p5HeightInput].forEach(function(input){
    input.addEventListener('change',render);
  });

  render();

  // -----------------------------------------------------------------------
  // 3D
  // -----------------------------------------------------------------------

  var viewBtn=document.getElementById('pg-view-3d');
  var modalOverlay=document.getElementById('pg-modal-overlay');
  var modalClose=document.getElementById('pg-modal-close');
  var modalCanvas=document.getElementById('pg-modal-canvas');
  var modalLoading=document.getElementById('pg-modal-loading');
  var modalSpec=document.getElementById('pg-modal-spec');
  var modalColorToggle=document.getElementById('pg-modal-color-toggle');
  var colorMode='grey',GREY_COLOR=0xa5abb1;
  var THREE_SRC='https://unpkg.com/three@0.128.0/build/three.min.js';
  var ORBIT_SRC='https://unpkg.com/three@0.128.0/examples/js/controls/OrbitControls.js';
  var BUFGEO_SRC='https://unpkg.com/three@0.128.0/examples/js/utils/BufferGeometryUtils.js';
  var JSZIP_SRC='https://unpkg.com/jszip@3.10.1/dist/jszip.min.js';
  var threeLoadState='idle',three=null;

  function injectScript(src,onLoad,onError){
    var s=document.createElement('script');s.src=src;s.async=true;s.onload=onLoad;
    s.onerror=onError||function(){};document.head.appendChild(s);
  }
  function ensureThreeLoaded(callback){
    if(threeLoadState==='ready'){callback(true);return;}
    if(threeLoadState==='error'){callback(false);return;}
    if(threeLoadState==='loading'){
      var check=setInterval(function(){
        if(threeLoadState==='ready'){clearInterval(check);callback(true);}
        else if(threeLoadState==='error'){clearInterval(check);callback(false);}
      },100);return;
    }
    threeLoadState='loading';
    injectScript(THREE_SRC,function(){
      injectScript(ORBIT_SRC,function(){
        injectScript(BUFGEO_SRC,function(){
          injectScript(JSZIP_SRC,function(){threeLoadState='ready';callback(true);},
          function(){threeLoadState='error';callback(false);});
        },function(){threeLoadState='error';callback(false);});
      },function(){threeLoadState='error';callback(false);});
    },function(){threeLoadState='error';callback(false);});
  }

  function roundedRectShape(x,y,w,h,r){
    var shape=new THREE.Shape();
    r=Math.max(0,Math.min(r,w/2,h/2));
    if(r<=0.0001){shape.moveTo(x,y);shape.lineTo(x+w,y);shape.lineTo(x+w,y+h);shape.lineTo(x,y+h);shape.closePath();return shape;}
    shape.moveTo(x+r,y);shape.lineTo(x+w-r,y);shape.quadraticCurveTo(x+w,y,x+w,y+r);
    shape.lineTo(x+w,y+h-r);shape.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    shape.lineTo(x+r,y+h);shape.quadraticCurveTo(x,y+h,x,y+h-r);
    shape.lineTo(x,y+r);shape.quadraticCurveTo(x,y,x+r,y);shape.closePath();
    return shape;
  }

  function roundedRectShapeCCW(x,y,w,h,r){
    var shape=new THREE.Shape();
    r=Math.max(0,Math.min(r,w/2,h/2));
    if(r<=0.0001){shape.moveTo(x,y);shape.lineTo(x,y+h);shape.lineTo(x+w,y+h);shape.lineTo(x+w,y);shape.closePath();return shape;}
    shape.moveTo(x,y+r);shape.quadraticCurveTo(x,y,x+r,y);
    shape.lineTo(x+w-r,y);shape.quadraticCurveTo(x+w,y,x+w,y+r);
    shape.lineTo(x+w,y+h-r);shape.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    shape.lineTo(x+r,y+h);shape.quadraticCurveTo(x,y+h,x,y+h-r);
    shape.closePath();
    return shape;
  }

  function rectPath(x,y,w,h){
    var path=new THREE.Path();
    path.moveTo(x,y);path.lineTo(x+w,y);path.lineTo(x+w,y+h);path.lineTo(x,y+h);path.closePath();
    return path;
  }

  function switchCutoutPath(cx,cy){
    var path=new THREE.Path();
    path.moveTo(cx-2.5,cy-7.5);path.lineTo(cx+2.5,cy-7.5);path.lineTo(cx+2.5,cy-7);
    path.lineTo(cx+7,cy-7);path.lineTo(cx+7,cy-2.5);path.lineTo(cx+7.5,cy-2.5);
    path.lineTo(cx+7.5,cy+2.5);path.lineTo(cx+7,cy+2.5);path.lineTo(cx+7,cy+7);
    path.lineTo(cx+2.5,cy+7);path.lineTo(cx+2.5,cy+7.5);path.lineTo(cx-2.5,cy+7.5);
    path.lineTo(cx-2.5,cy+7);path.lineTo(cx-7,cy+7);path.lineTo(cx-7,cy+2.5);
    path.lineTo(cx-7.5,cy+2.5);path.lineTo(cx-7.5,cy-2.5);path.lineTo(cx-7,cy-2.5);
    path.lineTo(cx-7,cy-7);path.lineTo(cx-2.5,cy-7);path.closePath();
    return path;
  }

  function extrudeMesh(shape,depth,material,partKey,edgeMaterial){
    var geometry=new THREE.ExtrudeGeometry(shape,{depth:depth,bevelEnabled:false,curveSegments:16});
    var mesh=new THREE.Mesh(geometry,material);mesh.userData.part=partKey;
    if(edgeMaterial){
      var edges=new THREE.LineSegments(new THREE.EdgesGeometry(geometry,25),edgeMaterial);
      edges.userData.isPartEdge=true;mesh.add(edges);
    }
    return mesh;
  }

  function roundedRectPoints(x,y,w,h,r,cx,cy,segs){
    segs=segs||16;r=Math.max(0,Math.min(r,w/2,h/2));
    var pts=[];
    [{x0:x+r,y0:y,cpx:x,cpy:y,x1:x,y1:y+r},{x0:x,y0:y+h-r,cpx:x,cpy:y+h,x1:x+r,y1:y+h},{x0:x+w-r,y0:y+h,cpx:x+w,cpy:y+h,x1:x+w,y1:y+h-r},{x0:x+w,y0:y+r,cpx:x+w,cpy:y,x1:x+w-r,y1:y}].forEach(function(c){
      for(var i=0;i<=segs;i++){var t=i/segs;pts.push((1-t)*(1-t)*c.x0+2*(1-t)*t*c.cpx+t*t*c.x1-cx,(1-t)*(1-t)*c.y0+2*(1-t)*t*c.cpy+t*t*c.y1-cy);}
    });
    return pts;
  }

  function makeRing(pts2d,z){
    var pos=[],n=pts2d.length/2;
    for(var i=0;i<n;i++)pos.push(pts2d[i*2],pts2d[i*2+1],z);
    pos.push(pts2d[0],pts2d[1],z);return pos;
  }
  function makeSquareRing(rect,z,cx,cy){
    var x=rect.x-cx,y=rect.y-cy,x2=x+rect.w,y2=y+rect.h;
    return [x,y,z,x2,y,z,x2,y2,z,x,y2,z,x,y,z];
  }

  function buildOutline(geo,v,cx,cy,edgeMaterial,partHeights,totalHeight){
    var segs=16;
    var Z_BOTTOM=-0.01,Z_TOP=totalHeight+0.01;
    var Z_INNER_START=partHeights.p1+partHeights.p2+partHeights.p3+partHeights.p4+0.01;
    var Z_CUTOUT_FLOOR=partHeights.p1>0?partHeights.p1-0.01:-0.01;
    var Z_CUTOUT_TOP=partHeights.p1+partHeights.p2+partHeights.p3+partHeights.p4+0.01;
    var outerPts=roundedRectPoints(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius,cx,cy,segs);
    var innerPts=roundedRectPoints(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius,cx,cy,segs);
    var group=new THREE.Group();
    function addRingLine(pts,z){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute(makeRing(pts,z),3));group.add(new THREE.Line(buf,edgeMaterial));}
    function addSquareLine(rect,z){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute(makeSquareRing(rect,z,cx,cy),3));group.add(new THREE.Line(buf,edgeMaterial));}
    function addVert(x,y,z1,z2){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute([x,y,z1,x,y,z2],3));group.add(new THREE.LineSegments(buf,edgeMaterial));}
    addRingLine(outerPts,Z_BOTTOM);addRingLine(outerPts,Z_TOP);
    var arcEnds=[0,segs,segs+1,2*(segs+1)-1,2*(segs+1),3*(segs+1)-1,3*(segs+1),4*(segs+1)-1];
    arcEnds.forEach(function(idx){addVert(outerPts[idx*2],outerPts[idx*2+1],Z_BOTTOM,Z_TOP);});
        if(partHeights.p5>0){addRingLine(innerPts,Z_TOP);addRingLine(innerPts,Z_INNER_START);}
    geo.black.forEach(function(b){
      addSquareLine(b,Z_CUTOUT_FLOOR);addSquareLine(b,Z_CUTOUT_TOP);
      var x1=b.x-cx,y1=b.y-cy,x2=x1+b.w,y2=y1+b.h;
      [[x1,y1],[x2,y1],[x2,y2],[x1,y2]].forEach(function(c){addVert(c[0],c[1],Z_CUTOUT_FLOOR,Z_CUTOUT_TOP);});
    });
    return group;
  }

  function buildModelGrey(v,material,edgeMaterial){
    var partHeights=getPartHeights(v.p1h,v.p5h),totalHeight=getTotalHeight(v.p1h,v.p5h);
    var geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var cx=geo.blue.x+geo.blue.w/2,cy=geo.blue.y+geo.blue.h/2;
    var group=new THREE.Group(),zCursor=0;
    function addLayer(shape,height){
      var g=new THREE.ExtrudeGeometry(shape,{depth:height,bevelEnabled:false,curveSegments:16});
      g.deleteAttribute('normal');g.computeVertexNormals();
      var m=new THREE.Mesh(g,material);m.position.set(-cx,-cy,zCursor);group.add(m);zCursor+=height;
    }
    if(v.p1h>0){
      var capH=Math.min(0.5,v.p1h);
      addLayer(roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius),capH);
      if(v.p1h>0.5){
        var p1Tube=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
        p1Tube.holes.push(roundedRectShape(geo.blue.x+0.01,geo.blue.y+0.01,geo.blue.w-0.02,geo.blue.h-0.02,v.outerRadius));
        addLayer(p1Tube,v.p1h-0.5);
      }
    } else {
      var p1Bot=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      p1Bot.holes.push(roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius));
      addLayer(p1Bot,0.01);
    }
    var outerRing=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    outerRing.holes.push(roundedRectShape(geo.blue.x+0.01,geo.blue.y+0.01,geo.blue.w-0.02,geo.blue.h-0.02,v.outerRadius));
    var owH=partHeights.p2+partHeights.p3+partHeights.p4+partHeights.p5;
    if(owH>0){
   var owg=new THREE.ExtrudeGeometry(outerRing,{depth:owH,bevelEnabled:false,curveSegments:16});
      owg.deleteAttribute('normal');owg.computeVertexNormals();
      var owm=new THREE.Mesh(owg,material);owm.position.set(-cx,-cy,zCursor);group.add(owm);
    }
    var p2cap=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    geo.black.forEach(function(b){p2cap.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    addLayer(p2cap,0.01);
    var p2=roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p2.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    addLayer(p2,partHeights.p2-0.01);
    var p3=roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p3.holes.push(switchCutoutPath(b.x+7,b.y+7));});
    addLayer(p3,partHeights.p3);
    var p4=roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p4.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    addLayer(p4,partHeights.p4-0.01);
    var p4cap=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    geo.black.forEach(function(b){p4cap.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    addLayer(p4cap,0.01);
    if(partHeights.p5>0){
      var p5=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      p5.holes.push(roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius));
      addLayer(p5,partHeights.p5);
    } else {
      var p5cap=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      geo.black.forEach(function(b){p5cap.holes.push(rectPath(b.x,b.y,b.w,b.h));});
      addLayer(p5cap,0.1);
    }
    group.add(buildOutline(geo,v,cx,cy,edgeMaterial,partHeights,totalHeight));
    return {group:group,width:geo.blue.w,depth:geo.blue.h,height:totalHeight};
  }




  function buildModelColor(v,materials,edgeMaterial){
    var partHeights=getPartHeights(v.p1h,v.p5h),totalHeight=getTotalHeight(v.p1h,v.p5h);
    var geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var cx=geo.blue.x+geo.blue.w/2,cy=geo.blue.y+geo.blue.h/2;
    var group=new THREE.Group(),zCursor=0;
    if(v.p1h>0){
      var p1=extrudeMesh(roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius),v.p1h,materials.p1,'p1',edgeMaterial);
      p1.position.set(-cx,-cy,zCursor);group.add(p1);zCursor+=v.p1h;
    }
    var p2Shape=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    geo.black.forEach(function(b){p2Shape.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    var p2=extrudeMesh(p2Shape,partHeights.p2,materials.p2,'p2',edgeMaterial);
    p2.position.set(-cx,-cy,zCursor);group.add(p2);zCursor+=partHeights.p2;
    var p3Shape=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    geo.black.forEach(function(b){p3Shape.holes.push(switchCutoutPath(b.x+7,b.y+7));});
    var p3=extrudeMesh(p3Shape,partHeights.p3,materials.p3,'p3',edgeMaterial);
    p3.position.set(-cx,-cy,zCursor);group.add(p3);zCursor+=partHeights.p3;
    var p4Shape=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
    geo.black.forEach(function(b){p4Shape.holes.push(rectPath(b.x,b.y,b.w,b.h));});
    var p4=extrudeMesh(p4Shape,partHeights.p4,materials.p4,'p4',edgeMaterial);
    p4.position.set(-cx,-cy,zCursor);group.add(p4);zCursor+=partHeights.p4;
    if(partHeights.p5>0){
      var p5Shape=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      p5Shape.holes.push(roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius));
      var p5=extrudeMesh(p5Shape,partHeights.p5,materials.p5,'p5',edgeMaterial);
      p5.position.set(-cx,-cy,zCursor);group.add(p5);
    }
    return {group:group,width:geo.blue.w,depth:geo.blue.h,height:totalHeight};
  }

  function buildModelGreyFrameless(v,material,edgeMaterial){
    var partHeights=getPartHeights(v.p1h,v.p5h),totalHeight=getTotalHeight(v.p1h,v.p5h);
    var geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var cx=geo.red.x+geo.red.w/2,cy=geo.red.y+geo.red.h/2;
    var group=new THREE.Group(),zCursor=0;
    function addLayer(shape,height){
      var g=new THREE.ExtrudeGeometry(shape,{depth:height,bevelEnabled:false,curveSegments:16});
      g.deleteAttribute('normal');g.computeVertexNormals();
      var m=new THREE.Mesh(g,material);m.position.set(-cx,-cy,zCursor);group.add(m);zCursor+=height;
    }
    function makeHole(b){
      var hole=new THREE.Path();
      hole.moveTo(b.x,b.y);hole.lineTo(b.x,b.y+b.h);
      hole.lineTo(b.x+b.w,b.y+b.h);hole.lineTo(b.x+b.w,b.y);
      hole.closePath();return hole;
    }
    function makeCrossHole(b){
      var cx3=b.x+7,cy3=b.y+7,hole=new THREE.Path();
      hole.moveTo(cx3-2.5,cy3-7);hole.lineTo(cx3-7,cy3-7);
      hole.lineTo(cx3-7,cy3-2.5);hole.lineTo(cx3-7.5,cy3-2.5);
      hole.lineTo(cx3-7.5,cy3+2.5);hole.lineTo(cx3-7,cy3+2.5);
      hole.lineTo(cx3-7,cy3+7);hole.lineTo(cx3-2.5,cy3+7);
      hole.lineTo(cx3-2.5,cy3+7.5);hole.lineTo(cx3+2.5,cy3+7.5);
      hole.lineTo(cx3+2.5,cy3+7);hole.lineTo(cx3+7,cy3+7);
      hole.lineTo(cx3+7,cy3+2.5);hole.lineTo(cx3+7.5,cy3+2.5);
      hole.lineTo(cx3+7.5,cy3-2.5);hole.lineTo(cx3+7,cy3-2.5);
      hole.lineTo(cx3+7,cy3-7);hole.lineTo(cx3+2.5,cy3-7);
      hole.lineTo(cx3+2.5,cy3-7.5);hole.lineTo(cx3-2.5,cy3-7.5);
      hole.closePath();return hole;
    }

// P1 — solid cap when > 0, hairline close when 0
if(v.p1h>0){
  addLayer(roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius),v.p1h);
}
    // P2
    var p2=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p2.holes.push(makeHole(b));});
    addLayer(p2,partHeights.p2);
    // P3
    var p3=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p3.holes.push(makeCrossHole(b));});
    addLayer(p3,partHeights.p3);
    // P4
    var p4=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p4.holes.push(makeHole(b));});
    addLayer(p4,partHeights.p4);
    // P5 — solid cap
    if(partHeights.p5>0){
      addLayer(roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius),partHeights.p5);
    } 
    // Outline
    var segs=16;
    var outerPts=roundedRectPoints(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius,cx,cy,segs);
    var og=new THREE.Group();
    var Z_BOTTOM=-0.01,Z_TOP=totalHeight+0.01;
    var Z_CF=v.p1h>0?v.p1h-0.01:-0.01;
    var Z_CT=v.p1h+partHeights.p2+partHeights.p3+partHeights.p4-0.01;
    function addRL(pts,z){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute(makeRing(pts,z),3));og.add(new THREE.Line(buf,edgeMaterial));}
    function addSL(rect,z){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute(makeSquareRing(rect,z,cx,cy),3));og.add(new THREE.Line(buf,edgeMaterial));}
    function addVS(x,y,z1,z2){var buf=new THREE.BufferGeometry();buf.setAttribute('position',new THREE.Float32BufferAttribute([x,y,z1,x,y,z2],3));og.add(new THREE.LineSegments(buf,edgeMaterial));}
    addRL(outerPts,Z_BOTTOM);addRL(outerPts,Z_TOP);
    var arcEnds=[0,segs,segs+1,2*(segs+1)-1,2*(segs+1),3*(segs+1)-1,3*(segs+1),4*(segs+1)-1];
    arcEnds.forEach(function(idx){addVS(outerPts[idx*2],outerPts[idx*2+1],Z_BOTTOM,Z_TOP);});
    geo.black.forEach(function(b){
      addSL(b,Z_CF);addSL(b,Z_CT);
      var x1=b.x-cx,y1=b.y-cy,x2=x1+b.w,y2=y1+b.h;
      [[x1,y1],[x2,y1],[x2,y2],[x1,y2]].forEach(function(c){addVS(c[0],c[1],Z_CF,Z_CT);});
    });
    group.add(og);
    return {group:group,width:geo.red.w,depth:geo.red.h,height:totalHeight};
  }

  function buildModelColorFrameless(v,materials,edgeMaterial){
    var partHeights=getPartHeights(v.p1h,v.p5h),totalHeight=getTotalHeight(v.p1h,v.p5h);
    var geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var cx=geo.red.x+geo.red.w/2,cy=geo.red.y+geo.red.h/2;
    var group=new THREE.Group(),zCursor=0;
    function addExtruded(shape,height,mat,partKey){
      var m=extrudeMesh(shape,height,mat,partKey,edgeMaterial);
      m.position.set(-cx,-cy,zCursor);group.add(m);zCursor+=height;
    }
    function makeHole(b){
      var hole=new THREE.Path();
      hole.moveTo(b.x,b.y);hole.lineTo(b.x,b.y+b.h);
      hole.lineTo(b.x+b.w,b.y+b.h);hole.lineTo(b.x+b.w,b.y);
      hole.closePath();return hole;
    }
    function makeCrossHole(b){
      var cx3=b.x+7,cy3=b.y+7,hole=new THREE.Path();
      hole.moveTo(cx3-2.5,cy3-7);hole.lineTo(cx3-7,cy3-7);
      hole.lineTo(cx3-7,cy3-2.5);hole.lineTo(cx3-7.5,cy3-2.5);
      hole.lineTo(cx3-7.5,cy3+2.5);hole.lineTo(cx3-7,cy3+2.5);
      hole.lineTo(cx3-7,cy3+7);hole.lineTo(cx3-2.5,cy3+7);
      hole.lineTo(cx3-2.5,cy3+7.5);hole.lineTo(cx3+2.5,cy3+7.5);
      hole.lineTo(cx3+2.5,cy3+7);hole.lineTo(cx3+7,cy3+7);
      hole.lineTo(cx3+7,cy3+2.5);hole.lineTo(cx3+7.5,cy3+2.5);
      hole.lineTo(cx3+7.5,cy3-2.5);hole.lineTo(cx3+7,cy3-2.5);
      hole.lineTo(cx3+7,cy3-7);hole.lineTo(cx3+2.5,cy3-7);
      hole.lineTo(cx3+2.5,cy3-7.5);hole.lineTo(cx3-2.5,cy3-7.5);
      hole.closePath();return hole;
    }
    if(v.p1h>0){
  addExtruded(roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius),v.p1h,materials.p1,'p1');
}
    var p2=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p2.holes.push(makeHole(b));});
    addExtruded(p2,partHeights.p2,materials.p2,'p2');
    var p3=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p3.holes.push(makeCrossHole(b));});
    addExtruded(p3,partHeights.p3,materials.p3,'p3');
    var p4=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
    geo.black.forEach(function(b){p4.holes.push(makeHole(b));});
    addExtruded(p4,partHeights.p4,materials.p4,'p4');
    if(partHeights.p5>0){
      addExtruded(roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius),partHeights.p5,materials.p5,'p5');
    }
    return {group:group,width:geo.red.w,depth:geo.red.h,height:totalHeight};
  }

  function buildModel(v,three){
    if(framelessMode){
      return colorMode==='grey'
        ?buildModelGreyFrameless(v,three.materials.grey,three.edgeMaterial)
        :buildModelColorFrameless(v,three.materials.color,three.edgeMaterial);
    }
    return colorMode==='grey'
      ?buildModelGrey(v,three.materials.grey,three.edgeMaterial)
      :buildModelColor(v,three.materials.color,three.edgeMaterial);
  }

  function initThreeScene(){
    var scene=new THREE.Scene();scene.background=new THREE.Color(0xf0f2f4);
    var camera=new THREE.PerspectiveCamera(22,1,0.1,5000);camera.up.set(0,0,1);
    var renderer=new THREE.WebGLRenderer({antialias:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    modalCanvas.appendChild(renderer.domElement);
    scene.add(new THREE.HemisphereLight(0xffffff,0x556677,1.05));
        var dir=new THREE.DirectionalLight(0xffffff,0.55);dir.position.set(120,-180,220);scene.add(dir);
    var dir2=new THREE.DirectionalLight(0xffffff,0.3);dir2.position.set(-150,120,-80);scene.add(dir2);
    var headlamp=new THREE.PointLight(0xffffff,0.05);camera.add(headlamp);scene.add(camera);
    var controls=new THREE.OrbitControls(camera,renderer.domElement);
    controls.enableDamping=true;controls.dampingFactor=0.08;
    var materials={
      color:{
        p1:new THREE.MeshStandardMaterial({color:0x2e3192,roughness:0.55,metalness:0.05}),
        p2:new THREE.MeshStandardMaterial({color:0xffffff,roughness:0.55,metalness:0.05}),
        p3:new THREE.MeshStandardMaterial({color:0x00a651,roughness:0.55,metalness:0.05}),
        p4:new THREE.MeshStandardMaterial({color:0x231f20,roughness:0.55,metalness:0.05}),
        p5:new THREE.MeshStandardMaterial({color:0xed1c24,roughness:0.55,metalness:0.05})
      },
      grey:new THREE.MeshStandardMaterial({color:GREY_COLOR,roughness:0.95,metalness:0.0,polygonOffset:true,polygonOffsetFactor:2,polygonOffsetUnits:2})
    };
    var edgeMaterial=new THREE.LineBasicMaterial({color:0x1a1a1a});
    return {scene:scene,camera:camera,renderer:renderer,controls:controls,group:null,animId:null,materials:materials,edgeMaterial:edgeMaterial};
  }

  function fitCameraToModel(t,width,depth,height){
    var target=new THREE.Vector3(0,0,height/2);
    var boundingRadius=Math.sqrt(width*width+depth*depth+height*height)/2*1.2;
    var fovRad=(t.camera.fov*Math.PI)/180,dist=boundingRadius/Math.sin(fovRad/2);
    var dir=new THREE.Vector3(0.85,-0.95,0.7).normalize();
    t.camera.position.copy(target).addScaledVector(dir,dist);
    t.camera.near=dist/100;t.camera.far=dist*20;t.camera.updateProjectionMatrix();
    t.controls.target.copy(target);t.controls.update();
  }

  function resizeThree(){
    if(!three)return;
    var w=modalCanvas.clientWidth||1,h=modalCanvas.clientHeight||1;
    three.camera.aspect=w/h;three.camera.updateProjectionMatrix();
    three.renderer.setSize(w,h,false);
  }

  function animateThree(){
    if(!three)return;
    three.animId=requestAnimationFrame(animateThree);
    three.controls.update();three.renderer.render(three.scene,three.camera);
  }

function refreshModel(refit){
  if(!three) return;
  var v = readInputs();
  if(three.group){
    three.scene.remove(three.group);
    three.group.traverse(function(obj){ if(obj.geometry) obj.geometry.dispose(); });
  }
  var built = buildModel(v, three);
  three.group = built.group;
  three.scene.add(built.group);
  if(refit) fitCameraToModel(three, built.width, built.depth, built.height);

  clearChildren(modalSpec);
  modalSpec.appendChild(specRow('Footprint', round(built.width) + 'mm × ' + round(built.depth) + 'mm'));
  modalSpec.appendChild(specRow('Total Height', round(built.height) + 'mm'));

  // Layer overlay
  var overlay = document.getElementById('pg-layer-overlay');
  var overlayContent = document.getElementById('pg-layer-overlay-content');
  if(overlay && overlayContent){
    clearChildren(overlayContent);
    if(colorMode === 'color'){
      function layerRow(label, height){
        if(height <= 0) return;
        var row = document.createElement('div');
        var labelSpan = document.createElement('span');
        labelSpan.style.fontWeight = '700';
        labelSpan.style.color = '#0b2540';
        labelSpan.textContent = label + ': ';
        var valSpan = document.createElement('span');
        valSpan.textContent = round(height).toFixed(1) + 'mm';
        row.appendChild(labelSpan);
        row.appendChild(valSpan);
        overlayContent.appendChild(row);
      }
if(!framelessMode && v.p5h > 0) layerRow('🟥 Top Frame', v.p5h);
layerRow('⬛ Plate Layer', FIXED_HEIGHTS.p4);
layerRow('🟩 Support A', FIXED_HEIGHTS.p3);
layerRow('⬜ Support B', FIXED_HEIGHTS.p2);
if(v.p1h > 0) layerRow('🟦 Base', v.p1h);
      overlay.classList.add('pg-show');
    } else {
      overlay.classList.remove('pg-show');
    }
  }
}


  function openModal(){
    modalOverlay.classList.add('pg-modal-open');
    modalLoading.style.display='flex';
    ensureThreeLoaded(function(ok){
      if(!ok){modalLoading.textContent='Could not load the 3D viewer. Check your connection and try again.';return;}
      if(!three){three=initThreeScene();}
      refreshModel(true);resizeThree();
      modalLoading.style.display='none';
      if(!three.animId)animateThree();
    });
  }

  function closeModal(){
    modalOverlay.classList.remove('pg-modal-open');
    if(three&&three.animId){cancelAnimationFrame(three.animId);three.animId=null;}
  }

  function export3MF(v,filename){
    var partHeights=getPartHeights(v.p1h,v.p5h);
    var geo=computeGeometry(v.rows,v.cols,v.pitch,v.outerWall);
    var cx=framelessMode?geo.red.x+geo.red.w/2:geo.blue.x+geo.blue.w/2;
    var cy=framelessMode?geo.red.y+geo.red.h/2:geo.blue.y+geo.blue.h/2;
    var SEGS=64,zCursor=0,geos=[];

    function addPart(shape,height){
      var g=new THREE.ExtrudeGeometry(shape,{depth:height,bevelEnabled:false,curveSegments:SEGS});
      g=g.toNonIndexed();g.translate(-cx,-cy,zCursor);geos.push(g);zCursor+=height;
    }
    function makeHole(b){
      var hole=new THREE.Path();
      hole.moveTo(b.x,b.y);hole.lineTo(b.x,b.y+b.h);
      hole.lineTo(b.x+b.w,b.y+b.h);hole.lineTo(b.x+b.w,b.y);
      hole.closePath();return hole;
    }
    function makeCrossHole(b){
      var cx3=b.x+7,cy3=b.y+7,hole=new THREE.Path();
      hole.moveTo(cx3-2.5,cy3-7);hole.lineTo(cx3-7,cy3-7);
      hole.lineTo(cx3-7,cy3-2.5);hole.lineTo(cx3-7.5,cy3-2.5);
      hole.lineTo(cx3-7.5,cy3+2.5);hole.lineTo(cx3-7,cy3+2.5);
      hole.lineTo(cx3-7,cy3+7);hole.lineTo(cx3-2.5,cy3+7);
      hole.lineTo(cx3-2.5,cy3+7.5);hole.lineTo(cx3+2.5,cy3+7.5);
      hole.lineTo(cx3+2.5,cy3+7);hole.lineTo(cx3+7,cy3+7);
      hole.lineTo(cx3+7,cy3+2.5);hole.lineTo(cx3+7.5,cy3+2.5);
      hole.lineTo(cx3+7.5,cy3-2.5);hole.lineTo(cx3+7,cy3-2.5);
      hole.lineTo(cx3+7,cy3-7);hole.lineTo(cx3+2.5,cy3-7);
      hole.lineTo(cx3+2.5,cy3-7.5);hole.lineTo(cx3-2.5,cy3-7.5);
      hole.closePath();return hole;
    }

    if(framelessMode){
      if(v.p1h>0){
        var fp1=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
        geo.black.forEach(function(b){fp1.holes.push(makeHole(b));});
        addPart(fp1,v.p1h);
      }
      var fp2=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
      geo.black.forEach(function(b){fp2.holes.push(makeHole(b));});
      addPart(fp2,partHeights.p2);
      var fp3=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
      geo.black.forEach(function(b){fp3.holes.push(makeCrossHole(b));});
      addPart(fp3,partHeights.p3);
      var fp4=roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius);
      geo.black.forEach(function(b){fp4.holes.push(makeHole(b));});
      addPart(fp4,partHeights.p4);
      if(partHeights.p5>0){
        addPart(roundedRectShapeCCW(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius),partHeights.p5);
      }
    } else {
      if(v.p1h>0) addPart(roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius),v.p1h);
      var p2s=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      geo.black.forEach(function(b){p2s.holes.push(rectPath(b.x,b.y,b.w,b.h));});
      addPart(p2s,partHeights.p2);
      var p3s=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      geo.black.forEach(function(b){p3s.holes.push(switchCutoutPath(b.x+7,b.y+7));});
      addPart(p3s,partHeights.p3);
      var p4s=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
      geo.black.forEach(function(b){p4s.holes.push(rectPath(b.x,b.y,b.w,b.h));});
      addPart(p4s,partHeights.p4);
      if(partHeights.p5>0){
        var p5s=roundedRectShape(geo.blue.x,geo.blue.y,geo.blue.w,geo.blue.h,v.outerRadius);
        p5s.holes.push(roundedRectShape(geo.red.x,geo.red.y,geo.red.w,geo.red.h,v.innerRadius));
        addPart(p5s,partHeights.p5);
      }
    }

    var merged=THREE.BufferGeometryUtils.mergeBufferGeometries(geos);
    geos.forEach(function(g){g.dispose();});
    merged.deleteAttribute('normal');merged.deleteAttribute('uv');merged.computeVertexNormals();
    var pos=merged.attributes.position,vertexCount=pos.count;
    var vertMap={},uniqueVerts=[],indices=[];
    for(var i=0;i<vertexCount;i++){
      var x=Math.round(pos.getX(i)*100)/100,y=Math.round(pos.getY(i)*100)/100,z=Math.round(pos.getZ(i)*100)/100;
      var key=x+','+y+','+z;
      if(vertMap[key]===undefined){vertMap[key]=uniqueVerts.length/3;uniqueVerts.push(x,y,z);}
      indices.push(vertMap[key]);
    }
    var faceMap={},triangleCount=indices.length/3;
    for(var t=0;t<triangleCount;t++){
      var i0=indices[t*3],i1=indices[t*3+1],i2=indices[t*3+2];
      if(i0===i1||i1===i2||i0===i2)continue;
      var sorted=[i0,i1,i2].sort(function(a,b){return a-b;});
      var faceKey=sorted[0]+'_'+sorted[1]+'_'+sorted[2];
      if(faceMap[faceKey]){delete faceMap[faceKey];}else{faceMap[faceKey]={v0:i0,v1:i1,v2:i2};}
    }
    var vertexXML='';
    for(var vi=0;vi<uniqueVerts.length;vi+=3){
      vertexXML+='<vertex x="'+uniqueVerts[vi]+'" y="'+uniqueVerts[vi+1]+'" z="'+uniqueVerts[vi+2]+'"/>';
    }
    var triangleXML='';
    for(var fk in faceMap){
      if(faceMap.hasOwnProperty(fk)){var f=faceMap[fk];triangleXML+='<triangle v1="'+f.v0+'" v2="'+f.v1+'" v3="'+f.v2+'"/>';}
    }
    merged.dispose();
    var modelXML='<?xml version="1.0" encoding="UTF-8"?>'+
      '<model unit="millimeter" xml:lang="en-US" xmlns="http://schemas.microsoft.com/3dmanufacturing/core/2015/02">'+
      '<resources><object id="1" type="model"><mesh>'+
      '<vertices>'+vertexXML+'</vertices><triangles>'+triangleXML+'</triangles>'+
      '</mesh></object></resources><build><item objectid="1"/></build></model>';
    var relsXML='<?xml version="1.0" encoding="UTF-8"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Target="/3D/3dmodel.model" Id="rel0" Type="http://schemas.microsoft.com/3dmanufacturing/2013/01/3dmodel"/></Relationships>';
    var contentTypesXML='<?xml version="1.0" encoding="UTF-8"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="model" ContentType="application/vnd.ms-package.3dmanufacturing-3dmodel+xml"/></Types>';
    var zip=new JSZip();
    zip.file('3D/3dmodel.model',modelXML);
    zip.file('_rels/.rels',relsXML);
    zip.file('[Content_Types].xml',contentTypesXML);
    zip.generateAsync({type:'blob'}).then(function(blob){
      var url=URL.createObjectURL(blob);
      var a=document.createElement('a');a.href=url;a.download=filename||'plate.3mf';
      document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
    });
  }

  window.addEventListener('resize',function(){if(modalOverlay.classList.contains('pg-modal-open'))resizeThree();});
  viewBtn.addEventListener('click',openModal);
  modalClose.addEventListener('click',closeModal);
  modalColorToggle.addEventListener('click',function(){
    colorMode=colorMode==='grey'?'color':'grey';
    modalColorToggle.textContent=colorMode==='grey'?'Show Layers':'Show Model';
    refreshModel(false);
  });
  modalOverlay.addEventListener('click',function(e){if(e.target===modalOverlay)closeModal();});
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      if(modalOverlay.classList.contains('pg-modal-open'))closeModal();
      if(svgModalOverlay.classList.contains('pg-modal-open'))closeSVGModal();
    }
  });
  [rowsInput,colsInput,pitchInput,outerWallInput,innerRadiusInput,outerRadiusInput,p1HeightInput,p5HeightInput].forEach(function(input){
    input.addEventListener('change',function(){
      if(modalOverlay.classList.contains('pg-modal-open')&&three)refreshModel(true);
    });
  });
  ['pg-outerwall','pg-outerradius','pg-p1-height','pg-p5-height'].forEach(function(id){
    root.querySelector('#'+id).parentElement.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(modalOverlay.classList.contains('pg-modal-open')&&three)refreshModel(true);
      });
    });
  });
  var download3mfBtn=document.getElementById('pg-modal-3mf');
  if(download3mfBtn){
    download3mfBtn.removeAttribute('disabled');
    download3mfBtn.addEventListener('click',function(){
      ensureThreeLoaded(function(ok){
        if(!ok)return;
        function waitForJSZip(cb){
          if(typeof JSZip!=='undefined'){cb();return;}
          var t=setInterval(function(){if(typeof JSZip!=='undefined'){clearInterval(t);cb();}},50);
        }
        waitForJSZip(function(){
          var v=readInputs();
          export3MF(v,'plate-'+v.rows+'x'+v.cols+'.3mf');
        });
      });
    });
  }

  var infoTrigger = document.querySelector('.pg-info-trigger');
  var infoTooltip = document.querySelector('.pg-info-tooltip');
  if(infoTrigger && infoTooltip){
    infoTrigger.addEventListener('click', function(e){
      e.stopPropagation();
      var active = infoTrigger.classList.toggle('pg-info-active');
      infoTooltip.style.opacity = active ? '1' : '0';
      infoTooltip.style.transform = active ? 'translateY(0)' : 'translateY(4px)';
    });
  }



})();

